const typesRequests = {
  Pending: 'Pending',
  Accepted: 'Accepted',
  Rejected: 'Rejected',
  Changed: 'Changed'
};

const typesRequestsMapping = (status: string) => {
  switch (status) {
    case 'Pending':
      return 'În așteptare';
    case 'Accepted':
      return 'Acceptată';
    case 'Rejected':
      return 'Refuzată';
    case 'Changed':
      return 'Schimbată';
  }
};

const mapStatusToColor = (status: string) => {
  return status.toLowerCase();
};
export { typesRequests, typesRequestsMapping, mapStatusToColor };
